// THE DIRECTOR'S POOL CHANGES — one rule for every Director this app drives (the TV receiver and the phone
// surface in receiver/journey.ts, the desktop/web player in Visualizer.tsx).
//
// A pool change (a TV's offer, a revoked entitlement, an un-starred favorite, the favorites filter) must judge
// where the Director is HEADED: the world on screen, or — mid-cross-fade — the one it is fading to. Judging only
// the world on screen let a fade land on a world that had just left the pool and hold it for its whole hold.
// When the heading world left the pool, the Director leaves it with a normal (quantized, cross-faded) cut; a
// request made mid-fade is held by the engine (0.15.6) and fires when the fade lands.
//
// Type-only imports: the headless suite loads this module straight into Node against the real engine.
import type { DirectorState, World } from '@syqel/engine'

/** Where a Director is headed: the world it is fading to mid-cross-fade, else the world on screen. */
export const directorHeading = (state: DirectorState): World => state.nextWorld ?? state.world

/** Hand the Director its new pool; if the world it is headed to left it, cut away now instead of holding it. */
export function repoolDirector(
  director: { setPool(pool: World[]): void; requestTransition(): void },
  pool: World[],
  heading: World | null
): void {
  director.setPool(pool)
  if (heading && !pool.some((w) => w.id === heading.id)) director.requestTransition()
}
